export default "__VITE_ASSET__DJ$nnX8y__"